import { getMetaContent } from 'helpers'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Card, CardText, Container } from 'reactstrap'
import ButtonAction from './ButtonAction'
import ItemsDetail from './Details'
import { getDataTrx } from './requestTransactionAction'
import './style.scss'
import UserInfo from './UserInfo'
import PaymentInfo from './PaymentInfo'

const OrderInfoView = () => {
  const [searchParams] = useSearchParams()
  const { detail } = useSelector((s) => s.reqTrxSell)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const code = searchParams.get('code')
  const amount = searchParams.get('totalAmount')

  const showAdjustment =
    detail?.orderDetail?.type === 'BUY' &&
    detail?.approvedAt &&
    detail?.adjustment &&
    (detail?.orderStatus === 'DISPUTE' ||
      (detail?.orderStatus === 'ON_GOING' &&
        detail?.adjustment?.status === 'APPROVE') ||
      (detail?.orderStatus === 'RELEASED_BY_BUYER' &&
        detail?.adjustment?.status === 'APPROVE'))

  useEffect(() => {
    if (!code || !amount) navigate('/')
  }, [code, amount, navigate])

  useEffect(() => {
    if (code && amount) {
      dispatch(getDataTrx({ code, amount }))
    }
  }, [code, amount])

  return (
    <Container
      className="d-flex align-items-center justify-content-center w-100 py-2"
      style={{ minHeight: '100vh' }}
    >
      <Card
        style={{ maxWidth: 480, maxHeight: '90vh' }}
        className="mx-auto px-2 d-flex flex-column w-100"
      >
        <img
          src={getMetaContent('og:image')}
          alt={`${getMetaContent('og:title')} logo`}
          className="mx-auto mt-4 mb-3"
          style={{
            width: '100%',
            maxWidth: '150px',
            height: 'auto',
          }}
        />

        <CardText tag="h4" className="mb-3 text-center">
          Permintaan {showAdjustment ? 'Penyesuaian' : ''} Transaksi
        </CardText>

        <CardText className="head-badges w-100 p-3">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              Transaksi{' '}
              {detail?.orderDetail?.type === 'SELL' ? 'Pembelian' : 'Penjualan'}
            </span>
            {detail?.orderStatus === 'RELEASED_BY_BUYER' ? (
              <div
                data-testid="order-status-badge"
                className="badge rounded-pill bg-success-50 text-success px-2"
              >
                Transaksi Selesai
              </div>
            ) : (
              <></>
            )}
          </div>
        </CardText>

        <div className="overflow-auto flex-grow-1 w-100">
          <UserInfo detail={detail} />
          <PaymentInfo detail={detail} />
          <ItemsDetail
            itemDetail={detail?.itemDetail}
            totalAmount={detail?.totalAmount}
            detail={detail}
          />
        </div>

        <div className="w-100 py-3">
          <ButtonAction code={code} amount={amount} data={detail} />
        </div>
      </Card>
    </Container>
  )
}

export default OrderInfoView
